import React from "react";
import "../assets/openroles.css";
import { Link } from 'react-router-dom';

const OpenRoles = () => {
    const jobs = [
        {
            title: "Business Developement Associate (BDA)",
            location: "Pune, Maharashtra, India",
            experience: "2 - 3 Years",
            type: "Full Time",
        },
        {
            title: "CR Executive (CRE)",
            location: "Pune, Maharashtra, India",
            experience: "2 - 4 Years",
            type: "Full Time",
        },
        {
            title: "Senior Relationship Manager (CM)",
            location: "Pune, Maharashtra, India",
            experience: "2 - 3 Years",
            type: "Full Time",
        },
        {
            title: "Site Operations Manager (SM)",
            location: "Lonavala, Maharashtra, India",
            experience: "3 - 6 Years",
            type: "Full Time",
        },
    ];

    return (
        <div className="open_roles_wrapper">
            {/* Top Gradient Band */}
            <div className="open_roles_hero" />

            {/* Search */}
            {/* <div className="open_roles_search_wrap">
                <input
                    className="open_roles_search"
                    placeholder="Search by role, department or location"
                />
            </div> */}

            <div className="open_roles_body">
                {/* Sidebar */}
                {/* <aside className="open_roles_filters">
                    <h4>Filters</h4>
                    <div className="open_roles_filter_box">Department <span>+</span></div>
                    <div className="open_roles_filter_box">Location <span>+</span></div>
                    <div className="open_roles_filter_box">Experience <span>+</span></div>
                </aside> */}

                {/* Main */}
                <main className="open_roles_list">
                    <div className="open_roles_header">
                        <h2>{jobs.length} Open jobs available</h2>
                        <select>
                            <option>Newest First</option>
                            <option>Oldest First</option>
                        </select>
                    </div>

                    {jobs.map((job, i) => (
                        <div className="open_roles_card" key={i}>
                            <h2>{job.title}</h2>
                            <div className="open_roles_meta">
                                <span>📍 {job.location}</span>
                                <span>🕒 {job.experience}</span>
                                <span>💼 {job.type}</span>
                            </div>

                            <div className="open_roles_actions">
                                <Link to={`/careers/job/${i}`}>
                                    <button className="open_roles_apply">
                                        <div>View & Apply</div></button>
                                </Link>

                            </div>
                        </div>
                    ))}
                </main>
            </div>
        </div>
    );
};

export default OpenRoles;
